import { render, staticRenderFns } from "./Profile_listpassenger.vue?vue&type=template&id=131c17b2&"
import script from "./Profile_listpassenger.vue?vue&type=script&lang=js&"
export * from "./Profile_listpassenger.vue?vue&type=script&lang=js&"
import style0 from "./Profile_listpassenger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports